window.dataLayer = window.dataLayer || [];
window.gtag = function (){
    dataLayer.push(arguments);
}
window.gtag('consent', 'default', {
    'ad_storage': 'denied',
    'ad_user_data': 'denied',
    'ad_personalization': 'denied',
    'analytics_storage': 'denied'
});

window.gtag('js', new Date());

window.g4_event = function (category, data, command) {
    data = data || {};
    command = command || 'event';
    
    window.gtag(command, category, data);
}

window.getQueryParams = function() {
    function identity (e) { return e; }
    function toKeyValue (params, param) {
        var keyValue = param.split('=');
        var key = keyValue[0], value = keyValue[1];

        params[key] = params[key]?[value].concat(params[key]):value;
        return params;
    }
    return decodeURIComponent(window.location.search).
    replace(/^\?/, '').split('&').
    filter(identity).
    reduce(toKeyValue, {});
}


window.requestLocation = function() {
    return new Promise((resolve, reject) => {

        if(!navigator || !navigator.geolocation) {
            return reject('Il tuo browser non supporta la Geolocalizzazione!');
        }

        $('body').addClass('onLoading');
        navigator.geolocation.getCurrentPosition((position) =>  {
            $('body').removeClass('onLoading');
            return resolve(position);
        }, () => {
            $('body').removeClass('onLoading');
            return reject("Per continuare devi autorizzare la localizzazione della tua posizione");
        });
    });
}

window.setupTooltips = function() {
    $('[data-toggle="tooltip"]').each(function(){
        var options = {
            html: true
        };

        if ($(this)[0].hasAttribute('data-type')) {
            options['template'] =
                '<div class="tooltip ' + $(this).attr('data-type') + '" role="tooltip">' +
                '	<div class="arrow"></div>' +
                '	<div class="tooltip-inner"></div>' +
                '</div>';
        }

        $(this).tooltip(options);
    });
}

window.redirect_nearby = async function(type, id, onErrorTargetModal) {

    try {
        let coord = await window.requestLocation();
        location.href= base_url + "nearby?type=" + type + "&id=" + id + "&lat=" + coord.coords.latitude + "&lon=" +coord.coords.longitude;
        return true;
    } catch (error) {
        if (onErrorTargetModal) {
            return showModalGeolocationError(onErrorTargetModal);
        }
        $('.searchwhere').val('').focus();
        return showError(error);
    }
}

window.showModalGeolocationError = function(modal) {
    $(modal).modal('show');
}

/**
 * @param {element} iconEl icon element
 * @param {string} inputId input id
 */
window.togglePasswordGroupIcon = function(iconEl, inputId, toggleIcon = 'fa-eye-slash') {
    togglePassword(inputId);
    iconEl.classList.toggle(toggleIcon);
    return false;
}

/**
 * @param {string} elementSelector selector of the input element
 * @returns
 */
window.togglePassword = function(elementId) {
    input = document.getElementById(elementId);

    if (!input || !input.type) return;

    const type = input.type === 'password' ? 'text' : 'password';
    input.type = type;
}


window.FbLogin = function() {
    if(typeof FB !== 'object') {
        showError('Errore durante il login con Facebook, prova a ricaricare la pagina e riprovare')
    }
    FB.login(function(response) {
        if (response.status !== 'connected') {
            var div = $('<div>').addClass('alert alert-danger alert-dismissible').html(
                '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>'+
                '<p><b>Login fallito!</b></p>'+
                'Per fare il login con Facebook abbiamo bisogno che autorizzi la nostra App a prendere i dati necessari dal tuo account'
            );
            return $('.response-facebook').html(div);
        }

        FB.api('/me', {fields: 'id,first_name,last_name,email,birthday'}, function(response) {
            if(!response.email) {
                var div = $('<div>').addClass('alert alert-danger alert-dismissible').html(
                    '<button type="button" class="close" data-dismiss="alert"><span aria-hidden="true">&times;</span></button>'+
                    '<p><b>Login fallito!</b></p>'+
                    'Per fare il login con Facebook abbiamo bisogno che autorizzi la nostra App a prendere l\'indirizzo email dal tuo account, per farlo rimuovi l\'app iDoctors <a href="https://www.facebook.com/settings/?tab=applications" target="_blank">dal tuo profilo</a> e riesegui l\'accesso'
                );
                return $('.response-facebook').html(div);
            }


            $('#unique-login-form input[name="fb_access_token"]').val(FB.getAccessToken());
            $('#unique-login-form input[name="fb_id"]').val(response.id);
            $('#unique-login-form input[name="email"]').val(response.email);
            $('#unique-login-form input[name="fb_login"]').val(1);
            $('#unique-login-form').trigger("submit");
        });
    }, {
        scope: 'public_profile, email'
    });
}

window.scrollTo = function (offset = null, duration = 300) {

    $('html').css('scroll-behavior', 'initial');
    $('html, body').animate({
        scrollTop: offset
    }, duration, function() {
        $('html').css('scroll-behavior', 'smooth');
    });
}

window.updateUserBadges = function ()
{
    if (! window.authUser) {
        return false;
    }
    //let's check if we have some notifications
    unreadMsg = parseInt(getCookie('unreadThreads'));
    unreadVideoconsulti = parseInt(getCookie('unreadVideoconsulti'));
    totalUnread = unreadMsg + unreadVideoconsulti;
    notify = '';
    if(totalUnread > 0) {
        notify = `<span class="badge badge-danger ml-1">${totalUnread}</span>`;
    }
    //search for data-href contains prenotazioni
    if (unreadVideoconsulti) {
        $('#authMenu li a[data-href*="prenotazioni"]').append('<span class="badge badge-danger ml-2">' + unreadVideoconsulti + '</span>');
    }
    if (unreadMsg) {
        $('#authMenu li a[data-href*="messaggi"]').append('<span class="badge badge-danger ml-2">' + unreadMsg + '</span>');
    }
    $('#authMenu .user-name').html(window.authUser.fullName + notify);
}